import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-xl bg-slate-950 text-white grid place-items-center font-display font-black">
              G
            </div>
            <div className="font-display font-extrabold tracking-tight text-slate-950 text-lg">
              Grant Football Coaching
            </div>
          </div>
          <p className="text-slate-600 leading-relaxed max-w-md">
            Development-heavy 1-1 football coaching in Hythe & Southampton. Position
            specific, skill specific, and football fitness sessions for players aged
            12-18.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-slate-950 mb-3">Coverage</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-blue-600" /> Southampton Sports Centre</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-blue-600" /> Hythe, Hampshire</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-blue-600" /> At-home & Astro options</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-slate-950 mb-3">Get in touch</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-blue-600 shrink-0" />
              <a href="mailto:jacobgranty1@gmail.com" data-testid="footer-email" className="hover:text-slate-900 break-all">jacobgranty1@gmail.com</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-blue-600 shrink-0" />
              <a href="tel:+447368242279" data-testid="footer-phone" className="hover:text-slate-900">+44 7368 242279</a>
            </li>
            <li className="flex items-center gap-2">
              <Instagram className="w-4 h-4 text-blue-600 shrink-0" />
              @grantfootball
            </li>
          </ul>
          <Link
            to="/book"
            data-testid="footer-book-link"
            className="inline-block mt-4 text-sm font-semibold text-blue-700 hover:text-blue-800"
          >
            Request a session →
          </Link>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Grant Football Coaching · Hythe & Southampton</div>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-slate-700">
            Coach login
          </Link>
        </div>
      </div>
    </footer>
  );
}
